export default "__VITE_ASSET__EOeLAVPM__"